<div *ngIf="!!customer">
  <div class="row mb-4">
    <div class="col d-flex flex-direction-row justify-content-between">
      <h3>{{ customer.name }}</h3>
      <lib-action-btn [item]="customer" [config]="configService"></lib-action-btn>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <lib-gung-tabset justify="fill" *ngIf="!!customer">
        <lib-gung-tab [title]="'DELIVERY_ADDRESS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="control-label" for="address" translate>FR_FTGPOSTADR1</label>
                  <input
                    class="form-control"
                    name="address"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftgpostadr1"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_FTGPOSTADR2</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftgpostadr2"
                    disabled
                  />
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="postalCode" translate>FR_FTGPOSTNR</label>
                      <input
                        class="form-control"
                        name="postalCode"
                        type="text"
                        [(ngModel)]="customer.extra.fr.ftgpostnr"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="ftgpostlevadr3" translate>CITY</label>
                      <input
                        class="form-control"
                        name="ftgpostlevadr3"
                        type="text"
                        [(ngModel)]="customer.extra.fr.ftgpostlevadr3"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_LANDSKOD</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra.fr.landskod"
                    disabled
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="control-label" for="contact" translate>CONTACT_PERSON_NAME</label>
                  <input class="form-control" name="contact" type="text" disabled />
                </div>

                <div class="form-group">
                  <label class="control-label" for="email" translate>EMAIL</label>
                  <input
                    class="form-control"
                    name="email"
                    type="text"
                    [(ngModel)]="customer.extra.kus.q_hl_default_email"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="phone" translate>PHONE</label>
                  <input class="form-control" name="phone" type="text" disabled />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <lib-gung-text-area-input
                  gungTranslate="NOTE"
                  [(ngModel)]="customer.extra.kus.edit"
                  rowsNumber="12"
                  disabled="true"
                ></lib-gung-text-area-input>
                <!-- <button type="button" class="btn btn-primary float-right" (click)="saveNote($event)" translate>SAVE</button> -->
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'CONTACTS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <lib-customer-contact-list></lib-customer-contact-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="showOrders" [title]="'ORDERS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <lib-order-list></lib-order-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="!isNoPrice" [title]="'INVOICES' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <gung-jeeves-jeeves-invoice-list></gung-jeeves-jeeves-invoice-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="isAdmin" [title]="'ACTIVITIES' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <lib-activity-internal-list [customerId]="customer.id"></lib-activity-internal-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="isAdmin && enableClaim" [title]="'CLAIMS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <colmec-claim-list *ngIf="customer?.id" [customerId]="customer.id"></colmec-claim-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>
